// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  button: "InfoTip__button",
  icon: "InfoTip__icon",
  tip: "InfoTip__tip",
  wrap: "InfoTip__wrap",
};
